import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';
import styled from 'styled-components';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <HeaderWrapper className={scrolled ? 'scrolled' : ''}>
      <div className="container">
        <div className="logo">
          <Link to="home" smooth={true} duration={500}>
            <span>Akash</span> Agarwal
          </Link>
        </div>

        <nav className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <ul>
            <li>
              <Link 
                to="home" 
                smooth={true} 
                duration={500} 
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="about" 
                smooth={true} 
                duration={500} 
                offset={-80}
                onClick={closeMenu}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="experience" 
                smooth={true} 
                duration={500} 
                offset={-80}
                onClick={closeMenu}
              >
                Experience
              </Link>
            </li>
            <li>
              <Link 
                to="certifications" 
                smooth={true} 
                duration={500} 
                offset={-80}
                onClick={closeMenu}
              >
                Certifications
              </Link>
            </li>
            <li>
              <Link 
                to="recommendations" 
                smooth={true} 
                duration={500} 
                offset={-80}
                onClick={closeMenu}
              >
                Recommendations
              </Link>
            </li>
            <li>
              <Link 
                to="contact" 
                smooth={true} 
                duration={500} 
                offset={-80}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
        </nav>

        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: 1.5rem 0;
  transition: all 0.3s ease;
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  &.scrolled {
    padding: 1rem 0;
    background-color: rgba(37, 99, 235, 0.95);
    backdrop-filter: blur(10px);
  }

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    a {
      color: white;
      font-size: 1.8rem;
      font-weight: 700;
      text-decoration: none;
      span {
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }


  .nav-menu {
    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
      position: fixed;
      top: 80px;
      left: -100%;
      width: 100%;
      height: calc(100vh - 80px);
      background-color: ${({ theme }) => theme.colors.primary};
      transition: all 0.5s ease;
      padding: 2rem 0;
      text-align: center;
      z-index: 999;

      &.active {
        left: 0;
      }
    }

    ul {
      display: flex;
      gap: 2rem;
      list-style: none;
      margin: 0;
      padding: 0;

      @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
        flex-direction: column;
        gap: 1.5rem;
      }

      li {
        a {
          color: white;
          font-weight: 500;
          font-size: 1.1rem;
          cursor: pointer;
          position: relative;
          padding: 0.5rem 0;

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 2px;
            background-color: white;
            transition: width 0.3s ease;
          }

          &:hover::after {
            width: 100%;
          }

          &.active {
            color: ${({ theme }) => theme.colors.secondary};
            &::after {
              width: 100%;
              background-color: ${({ theme }) => theme.colors.secondary};
            }
          }
        }
      }
    }
  }


  .hamburger {
    display: none;
    color: white;
    font-size: 1.8rem;
    cursor: pointer;
    z-index: 1001;

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
      display: block;
    }
  }
`;

export default Header;
